var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  購入には"+_vm._s(_vm.hostName)+"の会員登録が必要です。"),_c('br'),_vm._v("\n  登録済みの方はログインしてください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }